import './Error.css'

import React from 'react'

function Error() {
  return (
    <div className="error">
      <h1 className="error-msg">
        Something went wrong, please try again
      </h1>
    </div>
  )
}

export default Error